import { NgModule } from '@angular/core';
import { ElectricBorderDirective } from './electric-border.directive';

@NgModule({
    declarations: [
        ElectricBorderDirective
    ],
    imports: [],
    exports: [
        ElectricBorderDirective
    ]
})
export class NcElectricBorderModule { }